import type { Option } from '@freelancer/types';
import { isSome, none, some } from '@freelancer/types';
import * as Rx from 'rxjs';

/**
 * Remits the value from the source when requested.
 */
export function reemitWhen<T>(
  notifier$: Rx.Observable<unknown>,
): (source$: Rx.Observable<T>) => Rx.Observable<readonly [T, boolean]> {
  return (source$: Rx.Observable<T>) => {
    let latestSourceValue: Option<T> = none();

    return new Rx.Observable<[T, boolean]>(observer => {
      const subscriptions = new Rx.Subscription();

      subscriptions.add(
        source$.subscribe({
          next(newValue) {
            latestSourceValue = some(newValue);
            observer.next([newValue, false]);
          },
          error(err) {
            observer.error(err);
          },
          complete() {
            observer.complete();
          },
        }),
      );

      subscriptions.add(
        notifier$.subscribe({
          next() {
            if (isSome(latestSourceValue)) {
              observer.next([latestSourceValue.value, true]);
            }
          },
          error(err) {
            observer.error(err);
          },
        }),
      );

      return subscriptions;
    });
  };
}
